import { useSearchParams } from "react-router-dom";

/** Один параметр адреса как состояние: чтение и запись СЛИЯНИЕМ.
 *
 *  ⚠️ Слияние тут и есть весь смысл. Каждая страница писала свой параметр по-своему, и та, что
 *  перезаписывала строку целиком (`setParams({tab})`), молча роняла соседние — например `layout`,
 *  который пишет её же дочерний экран: щелчок по вкладке закрывал открытую раскладку.
 *
 *  Пустая строка удаляет параметр, чтобы умолчание не висело в адресе мусором.
 */
export function useUrlParam(key: string): [string, (value: string) => void] {
  const [params, setParams] = useSearchParams();
  const set = (value: string): void => {
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (value) next.set(key, value);
        else next.delete(key);
        return next;
      },
      { replace: true },
    );
  };
  return [params.get(key) ?? "", set];
}
